import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

export const Excitation = () => {
  return (
    <FilterAutocomplete
      label="Excitation"
      fieldName={'excitation'}
      fieldPath={'productInformation.excitation'}
    />
  )
}
